/**
 * Приводит произвольный язык i18next к корректной локали для `Intl.*`.
 * Например: "ru" → "ru-RU", "en" → "en-US".
 */
export const resolveIntlLocale = (lang: string): string => {
  if (lang.startsWith("ru")) return "ru-RU"
  return "en-US"
}
